import { useFetch } from 'hooks/useFetch';

export const usePowerBIReports = options => {
  const { data, ...rest } = useFetch('/api/powerbi/reports', options);

  const reports = data?.map(({ id, ...rest }) => ({ id: id.replaceAll('_', '-'), ...rest })) ?? [];

  return { reports, ...rest };
};
